import React from 'react'
import { css } from '@emotion/css'

export const iconPrefixTestId = 'tag-icon-prefix-test-id'

export function TagCount({ tagCount }: { tagCount: number }) {
  return (
    <span
      data-testid={iconPrefixTestId}
      className={css`
        font-size: 12px;
        padding-right: 2px;
        cursor: pointer;
      `}
    >{`(${tagCount < 99 ? tagCount : '99+'})`}</span>
  )
}
